import { NavLink, useNavigate } from 'react-router-dom';
import {
  LayoutDashboard, Search, Clock, Download, Users, Settings, LogOut, Library as LibIcon,
} from 'lucide-react';
import { tokens } from '../lib/api';

/** Logo der alten Oberflaeche — der Verlauf ist das einzige Gestaltungsstueck,
 *  das sich aus dem Bundle wiedergewinnen liess, und es bleibt. */
export function Marke({ size = 26 }: { size?: number }) {
  return (
    <svg width={size * 1.7} height={size} viewBox="0 0 68 40" fill="none" aria-label="AutoGrab">
      <defs>
        <linearGradient id="ag" x1="0" y1="40" x2="68" y2="0">
          <stop offset="0%" stopColor="#7aa7f0" />
          <stop offset="100%" stopColor="#e39ac8" />
        </linearGradient>
      </defs>
      <path d="M4 36 L20 6 L36 36" stroke="url(#ag)" strokeWidth="3.2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M64 12 a16 14 0 1 0 0 16 h-12" stroke="url(#ag)" strokeWidth="3.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

const EINTRAEGE = [
  { zu: '/', text: 'Übersicht', Icon: LayoutDashboard, exakt: true },
  { zu: '/search', text: 'Suche', Icon: Search },
  { zu: '/cron-jobs', text: 'Automatik', Icon: Clock },
  { zu: '/library', text: 'Mediathek', Icon: LibIcon },
  { zu: '/downloads', text: 'Downloads', Icon: Download },
];

const ADMIN = [
  { zu: '/admin/users', text: 'Benutzer', Icon: Users },
  { zu: '/admin/settings', text: 'Einstellungen', Icon: Settings },
];

export function Shell({ children, istAdmin }: { children: React.ReactNode; istAdmin: boolean }) {
  const nav = useNavigate();
  return (
    <div className="shell">
      <aside className="nav">
        <div className="nav__marke"><Marke size={22} /> AutoGrab</div>
        <div className="nav__gruppe">
          {EINTRAEGE.map(({ zu, text, Icon, exakt }) => (
            <NavLink
              key={zu}
              to={zu}
              end={exakt}
              className={({ isActive }) => `nav__eintrag${isActive ? ' nav__eintrag--aktiv' : ''}`}
            >
              <Icon size={17} /> {text}
            </NavLink>
          ))}
        </div>
        {istAdmin && (
          <div className="nav__gruppe">
            <div className="nav__titel">Verwaltung</div>
            {ADMIN.map(({ zu, text, Icon }) => (
              <NavLink
                key={zu}
                to={zu}
                className={({ isActive }) => `nav__eintrag${isActive ? ' nav__eintrag--aktiv' : ''}`}
              >
                <Icon size={17} /> {text}
              </NavLink>
            ))}
          </div>
        )}
        <div className="nav__fuss">
          <button
            className="nav__eintrag"
            style={{ width: '100%', background: 'none', border: 'none', textAlign: 'left' }}
            onClick={() => { tokens.clear(); nav('/login'); }}
          >
            <LogOut size={17} /> Abmelden
          </button>
        </div>
      </aside>
      <main className="haupt">{children}</main>
    </div>
  );
}
